export const NEW_SOURCE_FORM_LAYOUT = "NEW_SOURCE_FORM_LAYOUT";
export const SAVING_ANSWER = "SAVING_ANSWER";
export const DONE_SAVING_ANSWER = "DONE_SAVING_ANSWER";
export const VALIDATE_QUESTION_REQUIRED = "VALIDATE_QUESTION_REQUIRED";
